import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function User({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>User</title>
      <path
        d="M4.25 20C4.25 20.4142 4.58579 20.75 5 20.75C5.41421 20.75 5.75 20.4142 5.75 20H4.25ZM18.25 20C18.25 20.4142 18.5858 20.75 19 20.75C19.4142 20.75 19.75 20.4142 19.75 20H18.25ZM5.75 20V19H4.25V20H5.75ZM10 14.75H14V13.25H10V14.75ZM18.25 19V20H19.75V19H18.25ZM15.25 7C15.25 8.79493 13.7949 10.25 12 10.25V11.75C14.6234 11.75 16.75 9.62335 16.75 7H15.25ZM12 10.25C10.2051 10.25 8.75 8.79493 8.75 7H7.25C7.25 9.62335 9.37665 11.75 12 11.75V10.25ZM8.75 7C8.75 5.20507 10.2051 3.75 12 3.75V2.25C9.37665 2.25 7.25 4.37665 7.25 7H8.75ZM12 3.75C13.7949 3.75 15.25 5.20507 15.25 7H16.75C16.75 4.37665 14.6234 2.25 12 2.25V3.75ZM14 14.75C16.3472 14.75 18.25 16.6528 18.25 19H19.75C19.75 15.8244 17.1756 13.25 14 13.25V14.75ZM5.75 19C5.75 16.6528 7.65279 14.75 10 14.75V13.25C6.82436 13.25 4.25 15.8244 4.25 19H5.75Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
